import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { X, Cookie } from 'lucide-react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after 1 second
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []); // Empty deps - only run once on mount

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500">
      <Card className="max-w-4xl mx-auto bg-black/95 backdrop-blur-xl border border-white/20 shadow-2xl">
        <CardContent className="p-6">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-green-400 rounded-lg flex items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-black" />
            </div>
            
            <div className="flex-1">
              <h3 className="text-lg font-bold text-white mb-2">
                Utilizziamo i Cookie
              </h3>
              <p className="text-sm text-gray-300 leading-relaxed mb-4">
                Questo sito utilizza cookie tecnici necessari per il funzionamento e cookie analitici per migliorare la tua esperienza. 
                Continuando la navigazione accetti l'uso dei cookie.{' '}
                <Link to="/privacy-policy" className="text-orange-500 hover:text-orange-400 underline">
                  Leggi la Privacy Policy
                </Link>
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  onClick={acceptCookies}
                  className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold px-6 py-2 text-sm uppercase tracking-wide"
                >
                  Accetta Tutti
                </Button>
                <Button
                  onClick={declineCookies}
                  variant="outline"
                  className="border-white/20 bg-white/5 hover:bg-white/10 text-white font-bold px-6 py-2 text-sm uppercase tracking-wide"
                >
                  Solo Necessari
                </Button>
              </div>
            </div>

            <button
              onClick={declineCookies}
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="Chiudi"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CookieBanner;
